export const CMS_REVALIDATE_INTERVAL = 86400 // 1 day

export const CMS_FETCH_TIMEOUT_MS = 15_000

export const CMS_PAGE_CONCURRENCY = 6

export const CHANGELOG_REVALIDATE_SECONDS = 300 // 5 min

export const GITHUB_RELEASES_REVALIDATE_SECONDS = 86400 // 24h

export const GITHUB_RELEASES_STALE_WHILE_REVALIDATE_SECONDS = 3600 // 1h

export const GITHUB_RELEASES_EDGE_S_MAXAGE_SECONDS = 300 // 5 min

export const GITHUB_RELEASES_PARTIAL_S_MAXAGE_SECONDS = 120

export const GITHUB_RELEASES_PARTIAL_INSTANCE_MEMO_MS = 5 * 60 * 1000 // 5 min

export const GITHUB_STARS_EDGE_S_MAXAGE_SECONDS = 3600 // 1h

export const FOUNDRY_SCRIPT_REVALIDATE_SECONDS = 86400 // 24h

export const FOUNDRY_SCRIPT_STALE_WHILE_REVALIDATE_SECONDS = 3600 // 1h

export const FOUNDRY_SCRIPT_EDGE_S_MAXAGE_SECONDS = 300 // 5 min

export const FOUNDRY_SCRIPT_FALLBACK_S_MAXAGE_SECONDS = 120

export const FOUNDRY_SCRIPT_FALLBACK_INSTANCE_MEMO_MS = 5 * 60 * 1000 // 5 min

export const GITHUB_RELEASE_TAG_REVALIDATE_SECONDS = 300 // 5 min
